<template>
  <v-dialog v-model="visible" :max-width="maxWidth" persistent>
    <v-card>
      <v-toolbar dark flat dense :color="formColor">
        <v-toolbar-title><v-icon>{{ icon }}</v-icon> {{ title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-html="text" class="pt-4 pb-2"></v-card-text>
      <v-card-actions>

        <v-spacer />
        
        <v-btn :color="formColor" dark large class="rounded-0" @click="close">{{ getExpression('Button', 'OK') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { AppColor } from '@/config.js'
import AppAlert from '@/plugins/alert.js'

export default {
  name: 'AppAlert',
  data() {
    return {
      formColor: AppColor.Info,
      icon: 'info',
      visible: false,
      title: 'Info',
      text: null,
      width: 400,
      onClose: {}
    }
  },
  computed: {
    maxWidth () {
      return `${this.width}px`
    }
  },
  methods: {
    close () {
      const self = this
      self.visible = false
      if (typeof self.onClose === 'function') {
        self.onClose()
      }
    },
    show (params) {
      this.visible = true
      if (!this.isNullOrUndefined(params.title)) this.title = params.title
      if (!this.isNullOrUndefined(params.icon)) this.icon = params.icon
      if (!this.isNullOrUndefined(params.formColor)) this.formColor = params.formColor
      if (!this.isNullOrUndefined(params.width)) this.width = params.width
      if (!this.isNullOrUndefined(params.onClose)) this.onClose = params.onClose
      this.text = params.text
    }
  },
  beforeMount () {
    // here we need to listen for emited events
    // we declared those events inside our plugin
    AppAlert.EventBus.$on('show', (params) => {
      this.show(params)
    })
  }
}
</script>

<style>
  pre {
      white-space: pre-wrap;       /* Since CSS 2.1 */
      white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
      white-space: -pre-wrap;      /* Opera 4-6 */
      white-space: -o-pre-wrap;    /* Opera 7 */
      word-wrap: break-word;       /* Internet Explorer 5.5+ */
  }
</style>